import { useEffect, useState, useRef } from 'react';
import '../../assets/styles/_login.scss';

const GoogleCallback = () => {
  const [statusMessage, setStatusMessage] = useState('جاري التحقق من حسابك...');
  const [error, setError] = useState('');
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const errorParam = urlParams.get('error');

    const sendMessage = (type: string, data: any, closeDelay: number = 1000) => {
      Salla.event.emit('auth::social-media-login', { type, ...data });
      if (!window.opener) return;
      window.opener.postMessage({ type, ...data }, '*');
      setTimeout(() => window.close(), closeDelay);
    };

    if (errorParam) {
      const errorMsg = `فشل تسجيل الدخول: ${errorParam}`;
      setStatusMessage('حدث خطأ');
      setError(errorMsg);
      sendMessage('GOOGLE_LOGIN_ERROR', { error: { message: errorMsg } }, 3000);
      return;
    }

    if (!code) {
      const errorMsg = 'لم يتم استلام كود التفويض';
      setStatusMessage('حدث خطأ');
      setError(errorMsg);
      sendMessage('GOOGLE_LOGIN_ERROR', { error: { message: errorMsg } }, 3000);
      return;
    }

    setStatusMessage('جاري إتمام تسجيل الدخول...');
    sendMessage('GOOGLE_LOGIN_SUCCESS', { code, provider: 'google' });
  }, []);

  return (
    <div className="google-callback-container">
      <div className="loading-container">
        {!error && <div className="spinner" />}
        <h2 className="status-message">{statusMessage}</h2>
        {error && <div className="error-container"><div className="error">{error}</div></div>}
      </div>
    </div>
  );
};

export default GoogleCallback;
